export default "__VITE_ASSET__uL5B8LrL__"